import React, { useState, useEffect } from 'react';
import KnowledgeGraphDBConnectionForm from 'forms/KnowledgeGraphDBConnectionForm/KnowledgeGraphDBConnectionForm';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import services from 'services';
import { useMessage } from 'studio/components/Message';
import { useLoader } from 'components/loaders/FadeLoader';
import Typography from '@mui/material/Typography';
import { DatabaseIcon } from 'components/Icons';
import CodeSnippet from 'studio/components/CodeSnippet/CodeSnippet';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  ipAddress: {
    display: 'inline-flex',
    marginLeft: theme.spacing(1)
  }
}));

const DatabaseConnection = ({ knowledgeGraph }) => {
  const classes = useStyles();

  const [connection, setConnection] = useState(null);
  const [databases, setDatabases] = useState([]);
  const [modal, setModal] = useState({ open: false, message: 'modal message' });

  const { successMessage, errorMessage } = useMessage();
  const { withLoader, loading } = useLoader();

  const fetchDatabases = async () => {
    const result = await withLoader(services.getConnectors());
    if (result.success) {
      const databases = result.data.data.map(({ data }) => data).filter(({ type }) => type === 'DATABASE_CONNECTOR');

      setDatabases(databases);
      return;
    }
    const message = result?.response?.data?.message || 'There was an error fetching databases.';
    errorMessage(message);
  };

  const fetchDatabaseConnection = async id => {
    const result = await withLoader(services.getDatabaseConnection(id));
    if (result.success) {
      setConnection(result.data);
    }
  };

  const postConnection = async () => successMessage('Database saved successfully');

  useEffect(() => {
    fetchDatabases();
  }, []);

  useEffect(() => {
    if (knowledgeGraph && knowledgeGraph.data.id) {
      fetchDatabaseConnection(knowledgeGraph.data.id);
    }
  }, [knowledgeGraph]);

  return (
    <>
      <Typography variant="h2" gutterBottom>
        <DatabaseIcon />
        Database Connection
      </Typography>
      <Typography variant="body1" gutterBottom component="div">
        Ensure that the following IP address of Veezoo is whitelisted by your database:
        <CodeSnippet className={classes.ipAddress}>18.158.77.139</CodeSnippet>
      </Typography>
      <KnowledgeGraphDBConnectionForm
        databases={databases}
        connection={connection}
        successMessage={successMessage}
        errorMessage={errorMessage}
        withLoader={withLoader}
        loading={loading}
        knowledgeGraph={knowledgeGraph.data}
        postConnection={postConnection}
      />
      <Dialog
        maxWidth="xs"
        fullWidth
        open={modal.open}
        onClose={() => setModal(prevModal => ({ ...prevModal, open: false }))}
      >
        <DialogTitle>Database Connection</DialogTitle>
        <DialogContent>{modal.message}</DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setModal(prevModal => ({ ...prevModal, open: false }))}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DatabaseConnection;
